import React from "react"
import PropTypes from "prop-types"
import { useLocation } from "@reach/router"

import Logo from "@images/logo.svg"
import LogoDark from "@images/logo-dark.svg"
import Arrow from "@images/arrow-down.svg"
import ArrowDark from "@images/arrow-down-dark.svg"
import { useURLforArray } from "@hooks/siteURLs"
import { useRef, useEffect, useState } from "react"
import useWhatMenuShow from "@hooks/useWhatMenuShow"
import { BrandLogo, MenuOptions, OpenCloseMobileMenu } from "./menuElements"

import { menuOptions } from "./menuOptions"
import { use } from "i18next"

export const menus = menuOptions

export const getClassesForTheme = ({ theme, whatMenuShow }) => {
  const isDesktop = whatMenuShow === "desktop"

  const themedShadows = {
    mdBoxShadow: "md:shadow-[0_0.5px_0px_0px_rgba(255,255,255,0.2)]",
    smBoxShadowB: "shadow-[0_0.5px_0px_0px_rgba(255,255,255,0.2)]",
    smBoxShadowT: "shadow-[0_-0.5px_0px_0px_rgba(255,255,255,0.2)]",
  }

  let classesForTheme = {
    bgColor: "bg-white",
    textColor: "text-dblue",
    textActiveColor: "text-mgreen",
    mdBoxShadow: "md:shadow-[0_0.5px_0px_0px_rgba(21,17,36,0.2)]",
    smBoxShadowB: "shadow-[0_0.5px_0px_0px_rgba(21,17,36,0.2)]",
    smBoxShadowT: "shadow-[0_-0.5px_0px_0px_rgba(21,17,36,0.2)]",
    logoSrc: LogoDark,
    subMenuBackgroundColor: !isDesktop ? "bg-white" : "bg-dblue",
    subMenuTextColor: !isDesktop ? "text-dblue" : "text-white",
    arrowIcon: ArrowDark,
  }

  if (theme === "blue-bg") {
    classesForTheme.bgColor = "bg-dblue"
    classesForTheme.textColor = "text-white"
    classesForTheme.mdBoxShadow = themedShadows["mdBoxShadow"]
    classesForTheme.smBoxShadowB = themedShadows["smBoxShadowB"]
    classesForTheme.smBoxShadowT = themedShadows["smBoxShadowT"]
    classesForTheme.logoSrc = Logo
    classesForTheme.subMenuBackgroundColor = !isDesktop
      ? "bg-dblue"
      : "bg-white"
    classesForTheme.subMenuTextColor = !isDesktop ? "text-white" : "text-dblue"
    classesForTheme.arrowIcon = Arrow
  }

  if (theme === "gray-bg") {
    classesForTheme.bgColor = "bg-lblue"
    classesForTheme.mdBoxShadow = themedShadows["mdBoxShadow"]
    classesForTheme.smBoxShadowB = themedShadows["smBoxShadowB"]
    classesForTheme.smBoxShadowT = themedShadows["smBoxShadowT"]
    classesForTheme.logoSrc = Logo
    classesForTheme.arrowIcon = Arrow
  }

  return classesForTheme
}

export const MenuWrapper = ({
  children,
  theme,
  whatMenuShow,
  forceOnTop = false,
  navClassname = "",
}) => {
  const { bgColor, mdBoxShadow } = getClassesForTheme({ theme, whatMenuShow })

  return (
    <header
      className={`      
      flex 
      flex-wrap 
      items-center 
      justify-between 
      
      ${!forceOnTop && "fixed"}
      left-0
      right-0;
      w-full
      z-50
      ${bgColor}
      h-[70px]
      

      ${whatMenuShow !== "mobile" && "justify-start flex-nowrap"}
      ${whatMenuShow === "desktop" && "desk:h-[100px]"}
     
    `}
    >
      <nav
        className={`
        w-full
        flex
        flex-wrap md:flex-nowrap
        items-center 
        max-w-screen-fhd mx-auto
        justify-between
        relative 
        h-[70px]
		${navClassname}

        ${whatMenuShow !== "mobile" && mdBoxShadow}
        ${whatMenuShow === "desktop" && "desk:h-[100px] desk:px-12.5"}      
      `}
      >
        {children}
      </nav>
    </header>
  )
}

const MenuModule = ({
  theme,
  menus,
  isCollapse,
  setCollapse,
  getStartedEvent,
}) => {
  const ref = useRef(null)
  const [forceTabletMenu, setForceTabletMenu] = useState(false)
  const whatMenuShow = useWhatMenuShow(forceTabletMenu)
  const [isRendered, setIsRendered] = useState(false)
  const [menuSwitched, setMenuSwitched] = useState(false)
  const [menuWidth, setMenuWidth] = useState(0)

  const location = useLocation()

  if (
    !menuSwitched &&
    !isNaN(ref?.current?.clientHeight) &&
    ref?.current?.clientHeight > 100
  ) {
    setMenuSwitched(true)
    setForceTabletMenu(true)
    setMenuWidth(ref?.current?.clientWidth)
  }

  useEffect(() => {
    setIsRendered(true)
  }, [])
  const onCollapse = () => {
    setCollapse(prev => !prev)
  }

  const translatedUrls = useURLforArray([""])
  const {
    textColor,
    smBoxShadowB,
    bgColor,
    logoSrc,
    textActiveColor,
    smBoxShadowT,
    subMenuBackgroundColor,
    subMenuTextColor,
    arrowIcon,
  } = getClassesForTheme({
    theme,
    whatMenuShow,
  })
  return (
    <>
      <MenuWrapper theme={theme} whatMenuShow={whatMenuShow}>
        <div
          className={`
          w-full 
          
          flex
          flex-wrap 
          items-center 
          justify-between
          ${smBoxShadowB}
       
          relative
          z-30
      
          ${bgColor}
          h-[70px]
         
          
          
          ${
            whatMenuShow === "desktop" &&
            "desk:h-[100px] desk:shadow-none desk:w-auto desk:flex-nowrap   desk:z-auto"
          }
          
        `}
        >
          <BrandLogo
            logoSrc={logoSrc}
            logoUrl={translatedUrls[""]}
            isDesktop={whatMenuShow === "desktop"}
          />
          <OpenCloseMobileMenu
            isCollapse={isCollapse}
            textColor={textColor}
            onCollapse={onCollapse}
            isDesktop={whatMenuShow === "desktop"}
          />
        </div>
        <div ref={ref} className={`${!isRendered && "invisible h-[70px]"}`}>
          <MenuOptions
            getStartedEvent={getStartedEvent}
            textColor={textColor}
            textActiveColor={textActiveColor}
            isCollapse={isCollapse}
            bgColor={bgColor}
            smBoxShadowT={smBoxShadowT}
            theme={theme}
            menus={menus}
            subMenuBackgroundColor={subMenuBackgroundColor}
            subMenuTextColor={subMenuTextColor}
            arrowIcon={arrowIcon}
            whatMenuShow={whatMenuShow}
            isMobile={whatMenuShow === "mobile"}
            isTablet={whatMenuShow === "tablet"}
            forceToShowTabletMenu={forceTabletMenu}
          />
        </div>
      </MenuWrapper>

      {/* Floating call button visible only on mobile */}
      {whatMenuShow === "mobile" && location.pathname === "/" && isCollapse && (
        <a
          href="tel:+493021925897"
          className="fixed bottom-6 right-4 z-50 md:hidden bg-mgreen text-dblue rounded-full w-14 h-14 flex items-center justify-center shadow-lg"
          aria-label="Call us"
        >
          <svg
            className="w-6 h-6 fill-current"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
          </svg>
        </a>
      )}
    </>
  )
}

MenuModule.propTypes = {
  theme: PropTypes.oneOf(["blue-bg", "white-bg", "gray-bg"]),
  menus: PropTypes.array,
}

MenuModule.defaultProps = {
  theme: "blue-bg",
  menus,
}

export default MenuModule
